import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthContextProvider, useAuth } from "./contexts/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import WebsitePreloader from "./components/preloaders/WebsitePreloader";
import { ListsContextProvider } from "./contexts/ListsContext";

function App() {
  return (
    <div className="font-sans bg-gray-50 min-h-screen">
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <AuthContextProvider>
          <ListsContextProvider>
            <AppContent />
          </ListsContextProvider>
        </AuthContextProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  )
}

function AppContent() {
  const { loading } = useAuth();

  return loading ? <WebsitePreloader /> : <AppRoutes />;
}

export default App;
